/**
 * WattWächter Blue Theme - JavaScript
 * Professional, tech-forward interactions
 */

document.addEventListener('DOMContentLoaded', function() {
    // =============================================
    // HEADER SCROLL EFFECT
    // =============================================
    const header = document.querySelector('.header');

    window.addEventListener('scroll', () => {
        if (window.pageYOffset > 50) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    });

    // =============================================
    // MOBILE MENU
    // =============================================
    const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
    const navMenu = document.querySelector('.nav-menu');

    if (mobileMenuBtn && navMenu) {
        // Create mobile menu overlay
        const mobileMenu = document.createElement('div');
        mobileMenu.className = 'mobile-menu';
        mobileMenu.innerHTML = `
            <div class="mobile-menu-content">
                <nav class="mobile-nav">
                    ${navMenu.innerHTML}
                </nav>
            </div>
        `;
        // Im Mobile-Menü sind die Gruppen ausgeklappt: der Dropdown-Button wird zur Überschrift
        mobileMenu.querySelectorAll('.nav-group-toggle').forEach(toggle => {
            const label = document.createElement('span');
            label.className = 'nav-group-label';
            label.innerHTML = toggle.innerHTML;
            label.querySelector('.nav-group-chevron')?.remove();
            toggle.replaceWith(label);
        });
        document.body.appendChild(mobileMenu);

        // Add mobile menu styles
        const mobileStyles = document.createElement('style');
        mobileStyles.textContent = `
            .mobile-menu {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(15, 23, 42, 0.95);
                backdrop-filter: blur(20px);
                z-index: 9999;
                opacity: 0;
                visibility: hidden;
                transition: all 0.3s ease;
            }
            .mobile-menu.active {
                opacity: 1;
                visibility: visible;
            }
            .mobile-menu-content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 100%;
                padding: 24px;
            }
            .mobile-nav {
                display: flex;
                flex-direction: column;
                gap: 8px;
                width: 100%;
                max-width: 300px;
            }
            .mobile-nav li {
                list-style: none;
            }
            .mobile-nav a {
                display: block;
                padding: 16px 24px;
                color: white;
                font-size: 1.125rem;
                font-weight: 500;
                text-align: center;
                border-radius: 12px;
                transition: all 0.2s ease;
            }
            .mobile-nav a:hover {
                background: rgba(37, 99, 235, 0.2);
                color: #3b82f6;
            }
            .mobile-menu-btn.active span:nth-child(1) {
                transform: rotate(45deg) translate(5px, 5px);
            }
            .mobile-menu-btn.active span:nth-child(2) {
                opacity: 0;
            }
            .mobile-menu-btn.active span:nth-child(3) {
                transform: rotate(-45deg) translate(5px, -5px);
            }
        `;
        document.head.appendChild(mobileStyles);

        mobileMenuBtn.addEventListener('click', () => {
            mobileMenuBtn.classList.toggle('active');
            mobileMenu.classList.toggle('active');
            document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
        });

        // Close on link click
        mobileMenu.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', () => {
                mobileMenuBtn.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            });
        });
    }

    // =============================================
    // NAVIGATION DROPDOWNS (Strom / Gas)
    // =============================================
    const navGroups = document.querySelectorAll('.nav-menu .nav-group');

    function closeNavGroups(except) {
        navGroups.forEach(group => {
            if (group === except) return;
            group.classList.remove('open');
            group.querySelector('.nav-group-toggle')?.setAttribute('aria-expanded', 'false');
        });
    }

    navGroups.forEach(group => {
        const toggle = group.querySelector('.nav-group-toggle');
        if (!toggle) return;

        toggle.addEventListener('click', () => {
            const open = !group.classList.contains('open');
            closeNavGroups(group);
            group.classList.toggle('open', open);
            toggle.setAttribute('aria-expanded', String(open));
        });

        // Tastatur: Fokus verlässt die Gruppe → schließen
        group.addEventListener('focusout', (e) => {
            if (!group.contains(e.relatedTarget)) closeNavGroups();
        });
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.nav-menu .nav-group')) closeNavGroups();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const openGroup = document.querySelector('.nav-menu .nav-group.open');
        if (!openGroup) return;
        closeNavGroups();
        openGroup.querySelector('.nav-group-toggle')?.focus();
    });

    // =============================================
    // FAQ ACCORDION
    // =============================================
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
        const trigger = item.querySelector('.faq-trigger');

        trigger?.addEventListener('click', () => {
            const isActive = item.classList.contains('active');

            // Close all other items
            faqItems.forEach(otherItem => {
                otherItem.classList.remove('active');
            });

            // Toggle current item
            if (!isActive) {
                item.classList.add('active');
            }
        });
    });

    // =============================================
    // SMOOTH SCROLL
    // =============================================
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href === '#') return;

            e.preventDefault();
            const target = document.querySelector(href);

            if (target) {
                const headerHeight = header?.offsetHeight || 72;
                const targetPosition = target.offsetTop - headerHeight - 20;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

    // =============================================
    // NOTIFY FORM (Coming Soon Product)
    // =============================================
    document.querySelectorAll('.notify-input button').forEach(btn => {
        btn.addEventListener('click', function() {
            const input = this.parentElement.querySelector('input');
            if (input.value) {
                const originalHTML = this.innerHTML;
                this.innerHTML = '<i class="fas fa-check"></i>';
                input.value = '';

                setTimeout(() => {
                    this.innerHTML = originalHTML;
                }, 2000);
            }
        });
    });

    // =============================================
    // INTERSECTION OBSERVER ANIMATIONS
    // =============================================
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const animateOnScroll = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-in');
                animateOnScroll.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Apply to elements
    document.querySelectorAll('.product-card, .step, .feature-tile, .review-card, .compat-item, .faq-item, .int-item').forEach((el, index) => {
        el.classList.add('animate-on-scroll');
        el.style.transitionDelay = `${Math.min(index * 0.05, 0.3)}s`;
        animateOnScroll.observe(el);
    });

    // =============================================
    // PRODUCT CARDS HOVER EFFECT
    // =============================================
    document.querySelectorAll('.product-card').forEach(card => {
        card.addEventListener('mouseenter', function() {
            if (!this.classList.contains('coming-soon')) {
                this.style.transform = 'translateY(-8px)';
            }
        });

        card.addEventListener('mouseleave', function() {
            this.style.transform = '';
        });
    });

    // Cart count element (used by Shopify natively)
    const cartCount = document.querySelector('.cart-count');

    // =============================================
    // TOAST NOTIFICATION
    // =============================================
    function showToast(message) {
        // Remove existing toast
        document.querySelector('.toast')?.remove();

        const toast = document.createElement('div');
        toast.className = 'toast';
        toast.innerHTML = `
            <i class="fas fa-check-circle"></i>
            <span>${message}</span>
        `;

        // Add styles if not exist
        if (!document.querySelector('#toast-styles')) {
            const styles = document.createElement('style');
            styles.id = 'toast-styles';
            styles.textContent = `
                .toast {
                    position: fixed;
                    bottom: 24px;
                    left: 50%;
                    transform: translateX(-50%);
                    background: #0f172a;
                    color: white;
                    padding: 14px 24px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
                    z-index: 10000;
                    animation: toastIn 0.3s ease;
                }
                .toast i {
                    color: #10b981;
                    font-size: 1.125rem;
                }
                @keyframes toastIn {
                    from {
                        opacity: 0;
                        transform: translateX(-50%) translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(-50%) translateY(0);
                    }
                }
                @keyframes toastOut {
                    from {
                        opacity: 1;
                        transform: translateX(-50%) translateY(0);
                    }
                    to {
                        opacity: 0;
                        transform: translateX(-50%) translateY(20px);
                    }
                }
            `;
            document.head.appendChild(styles);
        }

        document.body.appendChild(toast);

        // Auto remove after 3 seconds
        setTimeout(() => {
            toast.style.animation = 'toastOut 0.3s ease forwards';
            setTimeout(() => toast.remove(), 300);
        }, 3000);
    }

    // =============================================
    // POWER VALUE ANIMATION
    // =============================================
    const dataValue = document.querySelector('.card-power .data-value');

    if (dataValue) {
        let currentWatts = 247;

        setInterval(() => {
            const change = Math.random() * 300 - 150;
            currentWatts = Math.max(50, Math.min(2750, currentWatts + change));
            dataValue.textContent = Math.round(currentWatts) + ' W';
        }, 2000);
    }

    // Gas-Durchfluss im Hero der Startseite (m³/h, deutsches Zahlenformat)
    const gasFlowValue = document.querySelector('.card-gasflow .data-value');

    if (gasFlowValue) {
        let currentFlow = 0.218;

        setInterval(() => {
            const change = Math.random() * 0.12 - 0.06;
            currentFlow = Math.max(0.05, Math.min(1.2, currentFlow + change));
            gasFlowValue.textContent = currentFlow.toFixed(3).replace('.', ',') + ' m³/h';
        }, 2500);
    }

    // =============================================
    // METER READING ANIMATION
    // =============================================
    const meterReading = document.querySelector('.reading');

    if (meterReading) {
        let currentReading = 2847.3;

        setInterval(() => {
            currentReading += Math.random() * 0.05;
            meterReading.textContent = currentReading.toFixed(1).padStart(8, '0');
        }, 3000);
    }

    // =============================================
    // GRADIENT ORB PARALLAX
    // =============================================
    const orbs = document.querySelectorAll('.gradient-orb');

    if (orbs.length && window.innerWidth > 768) {
        window.addEventListener('scroll', () => {
            const scrolled = window.pageYOffset;

            orbs.forEach((orb, index) => {
                const speed = (index + 1) * 0.02;
                orb.style.transform = `translate(${scrolled * speed}px, ${scrolled * speed}px)`;
            });
        });
    }

    // =============================================
    // FEATURE TILES STAGGER ANIMATION
    // =============================================
    const featureTiles = document.querySelectorAll('.feature-tile');

    const tileObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
                tileObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });

    featureTiles.forEach((tile, index) => {
        tile.style.opacity = '0';
        tile.style.transform = 'translateY(20px)';
        tile.style.transition = `opacity 0.4s ease ${index * 0.1}s, transform 0.4s ease ${index * 0.1}s`;
        tileObserver.observe(tile);
    });

    // =============================================
    // STEP NUMBER ANIMATION
    // =============================================
    const stepNums = document.querySelectorAll('.step-num');

    const stepObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.style.animation = 'popIn 0.5s ease forwards';
                stepObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    // Add pop animation
    const popStyles = document.createElement('style');
    popStyles.textContent = `
        @keyframes popIn {
            0% {
                transform: scale(0);
                opacity: 0;
            }
            70% {
                transform: scale(1.15);
            }
            100% {
                transform: scale(1);
                opacity: 1;
            }
        }
    `;
    document.head.appendChild(popStyles);

    stepNums.forEach((num, index) => {
        num.style.opacity = '0';
        num.style.animationDelay = `${index * 0.15}s`;
        stepObserver.observe(num);
    });

    // =============================================
    // REVIEW CARDS TILT EFFECT
    // =============================================
    if (window.innerWidth > 768) {
        document.querySelectorAll('.review-card').forEach(card => {
            card.addEventListener('mousemove', (e) => {
                const rect = card.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;

                const centerX = rect.width / 2;
                const centerY = rect.height / 2;

                const rotateX = (y - centerY) / 25;
                const rotateY = (centerX - x) / 25;

                card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-4px)`;
            });

            card.addEventListener('mouseleave', () => {
                card.style.transform = '';
            });
        });
    }

    // =============================================
    // INTEGRATION ITEMS HOVER
    // =============================================
    document.querySelectorAll('.int-item').forEach(item => {
        item.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-4px)';
        });

        item.addEventListener('mouseleave', function() {
            this.style.transform = '';
        });
    });

    // =============================================
    // EU-GEWÄHRLEISTUNGS-MITTEILUNG (Dialog)
    // Trigger sind Links auf /pages/gewaehrleistung; mit JS öffnen sie
    // stattdessen den globalen <dialog> (snippets/gewaehrleistung-dialog.liquid).
    // =============================================
    const gwDialog = document.getElementById('gewaehrleistung-dialog');

    if (gwDialog && typeof gwDialog.showModal === 'function') {
        document.addEventListener('click', (e) => {
            const opener = e.target.closest('[data-gw-open]');

            if (opener) {
                e.preventDefault();
                gwDialog.showModal();
                return;
            }

            // Schließen über Button oder Klick auf den Backdrop (Dialog selbst, nicht Inhalt)
            if (gwDialog.open && (e.target.closest('[data-gw-close]') || e.target === gwDialog)) {
                gwDialog.close();
            }
        });
    }

});
